const ROLES = {
  System: 1,
  Administrators: 2,
  Professors: 3,
  StudentsAdvanced: 4,
  StudentsBasic: 5
};

export { ROLES };
